module.exports = "<footer>\n  <p class=\"uppercase\">© AM - Made With Love <i class=\"ion-heart\"></i> And CODE <i class=\"ion-code\"></i></p>\n  <div class=\"drag\">\n    <i class=\"up ion-arrow-up-c\"></i>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main